<script setup>

import SwitchInput from "@/Components/SwitchInput.vue";
import Card from "@/Components/Card.vue";
import {ref, watch} from "vue";
import PropertyInput from "@/Components/PropertyInput.vue";
import PropertyInputRange from "@/Components/PropertyInputRange.vue";
import {usePage} from "@inertiajs/vue3";

const props = defineProps({
    lotId: Number | String,
    propertyValues: Object,
    properties: Object,
    lotsActive: Object,
    havePropertyValue: {
        type: Boolean,
        default: false
    }
})

const emits = defineEmits(['update:lotId', 'updatePropertyValues', 'clearFilters'])

const page = usePage();

const showFilters = ref(true)
const clearPropertyValues = () => {
    emits('clearFilters');
}

watch(() => props.propertyValues, (newVal, oldValue) => {
    if(Object.keys(newVal) === Object.keys(oldValue)) {
        emits('updatePropertyValues', newVal)
    }
}, {deep: true})

</script>

<template>
    <div class="flex-col grow gap-2.5 shrink-0">
        <Card class="p-2.5 flex flex-wrap gap-2 w-full">
            <button
                :class="{'bg-black dark:bg-slate-200 border-black dark:border-slate-200 text-white dark:!text-dark-blue' : lotId === 'all'}"
                @click="emits('update:lotId', 'all')"
                class="h-8 rounded-lg border border-slate-500 dark:border-slate-400 text-slate-500 dark:text-slate-400
                        flex items-center justify-center cursor-pointer font-condensed font-medium
                         hover:bg-black dark:hover:bg-slate-200 hover:border-black dark:hover:border-slate-200 hover:text-white dark:hover:text-dark-blue transition-colors px-2.5 text-sm">
                <span>{{ $t('All') }}</span></button>
            <template v-for="lot in lotsActive">
                <button
                    :class="{'bg-black dark:bg-slate-200 dark:text-dark-blue border-black dark:border-slate-200 text-white dark:!text-dark-blue' : lotId === lot.id}"
                    @click="emits('update:lotId', lot.id)"
                    class="h-8 rounded-lg border border-slate-500 dark:border-slate-400 text-slate-500 dark:text-slate-400
                        flex items-center justify-center cursor-pointer font-condensed font-medium
                         hover:bg-black dark:hover:bg-slate-200 hover:border-black dark:hover:border-slate-200 hover:text-white dark:hover:text-dark-blue transition-colors px-2.5 text-sm">
                    <span>{{ lot.title }}</span></button>
            </template>
        </Card>
        <Card v-if="lotId !== 'all' && properties && properties?.length > 0">
            <div class="flex p-2.5 justify-between items-center">
                <SwitchInput :disabled="lotId === 'all'" v-model="showFilters" class="text-sm font-medium"
                             :title="$t('Filters')"></SwitchInput>
                <button v-if="havePropertyValue" @click="clearPropertyValues()"
                        class="text-blue-600 underline cursor-pointer text-xs lowercase">
                    {{$t('reset filters')}}
                </button>
            </div>
            <template v-if="showFilters && propertyValues">
                <template v-for="(property, index) in properties">
                    <template v-if="propertyValues[property?.id]">
                        <PropertyInput
                            v-if="property.type !== 'int' && property.type !== 'float'"
                            v-model="propertyValues[property.id].value"
                            :property="property"
                            @update:model-value="emits(`updatePropertyValues`, propertyValues)"
                            class="border-b border-dashed border-slate-300 dark:border-slate-700"
                            :class="{'lg:border-t':index === 0}"
                        />
                        <PropertyInputRange
                            v-else
                            v-model:from="propertyValues[property.id].value_from"
                            v-model:to="propertyValues[property.id].value_to"
                            @update:from="emits(`updatePropertyValues`, propertyValues)"
                            @update:to="emits(`updatePropertyValues`, propertyValues)"
                            :property="property"
                            class="border-b border-dashed border-slate-300 dark:border-slate-700"
                            :class="{'lg:border-t':index === 0}"
                        />
                    </template>
                </template>
                <div class="py-1.25"></div>
            </template>
        </Card>
    </div>
</template>

<style scoped>

</style>
